import React from 'react';
import About from '../components/About';
import Footer from '../components/Footer';

function AboutPage() {
  return (
    <div className="page">
      <main>
        <About />
      </main>
      <Footer />
    </div>
  );
}

export default AboutPage;
